// @core/api/endpoints/bootstrap/reset.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ResetBootstrapRequest,
  ResetBootstrapResponse,
} from '../../../types/bootstrap';

const BASE_PATH = '/bootstrap';

/**
 * Reset bootstrap
 * Resets the bootstrap wizard to initial state. Only available if bootstrap has not completed. Does NOT reset the secret service if already initialized.
 * @public This endpoint does not require authentication
 */
export async function Reset(
  data: ResetBootstrapRequest,
  options?: RequestOptions
): Promise<ResetBootstrapResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/setup/reset`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<ResetBootstrapResponse>(requestPath, data, requestOptions);
}
